








import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    content: require('@/content/help.md'),
  }),
})
